<template>
  <div class="home">
    <div class="bg"><img v-lazy="require('../assets/image/bg@2x.png')" alt=""></div>
    <div class="charge"><img v-lazy="require('../assets/image/charge@2x.png')" alt=""></div>
    <div class="instruction"><img v-lazy="require('../assets/image/instruction@2x.png')" alt=""></div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
}
</script>
<style lang="scss">
  .home{
    background: #FF8950;
    img{
      width: 18.75rem;
      height: auto;
    }
  }
</style>
